'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * passez en attribut application (nm de l'application)
 */
ngModule.directive("tlApplicationIcon", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<i tl-tooltip class=\"mr-s module-dette\" ng-class=\"[applicationClass]\">\n<tl-tooltip-content><div>{{'lov.applicationsClients.'+application|translate}}</div></tl-tooltip-content>\n{{'lov.applicationsClients.initial.'+application|translate}}\n</i>",
    link: function link($scope, $el, $attrs) {
      $scope.application = $attrs.application;
      $scope.applicationClass = "application-" + $scope.application;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-application-icon.js
// module id = 2853
// module chunks = 13